import ContentfulPreOrderModal from '@src/quince-site-common/src/domains/contentful/ContentfulPreOrder'

import PreOrderMessage from '../preOrderMessage/PreOrderMessage'
import { VariantPurchaseInfo } from '../productForm/ProductForm'

import { CTA_TYPE } from './productCTAConstants'

interface ProductMessageType {
  type: any
  selectedVariantPurchaseInfo?: VariantPurchaseInfo | undefined
  preOrderModalData?: ContentfulPreOrderModal | undefined
  customMessage?: string
  showNewPdpDesignV2?: boolean
  isQuickATCModal?: boolean
}

function ProductMessage({
  type,
  selectedVariantPurchaseInfo,
  preOrderModalData,
  customMessage = undefined,
  showNewPdpDesignV2 = false,
  isQuickATCModal = false,
}: ProductMessageType) {
  if (type !== CTA_TYPE.PREORDER) {
    return null
  }

  return (
    <PreOrderMessage
      selectedVariantId={selectedVariantPurchaseInfo?.selectedVariantId}
      preOrderModalData={preOrderModalData}
      preOrderShippingDate={selectedVariantPurchaseInfo?.preOrderShippingDate}
      customMessage={customMessage}
      showNewPdpDesignV2={showNewPdpDesignV2}
      isQuickATCModal={isQuickATCModal}
    />
  )
}

export default ProductMessage
